import TextField from '@components/v2/form/TextField/TextField';
import Icon from '@components/v2/ui/Icon/Icon';
import { InputAdornment } from '@mui/material';
import { Control, FieldValues, Path, useController } from 'react-hook-form';
import { SocialMediaFieldConfig } from './socialMediaField.types';

type SocialMediaFieldProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  socialMedia: Omit<SocialMediaFieldConfig, 'name'>;
};

const SocialMediaField = <T extends FieldValues>({
  control,
  name,
  socialMedia,
}: SocialMediaFieldProps<T>) => {
  const { field, fieldState } = useController({ control, name });

  return (
    <TextField
      name={field.name}
      label={socialMedia.label}
      value={field.value ?? ''}
      error={Boolean(fieldState.error)}
      helperText={fieldState.error?.message}
      testId={field.name}
      ref={field.ref}
      onChange={field.onChange}
      onBlur={field.onBlur}
      slotProps={{
        input: {
          startAdornment: (
            <>
              <InputAdornment position="start" sx={{ color: 'text.secondary' }}>
                <Icon icon={socialMedia.icon} size="md" />
              </InputAdornment>
              <InputAdornment position="start">{socialMedia.urlPrefix}</InputAdornment>
            </>
          ),
        },
      }}
    />
  );
};

export default SocialMediaField;
